import { noop } from 'lodash'

/** Factory Components **/
import InlineText from './components/InlineText'
import PipeText from './components/PipeText'
import SingleText from './components/SingleText'
import Table from './components/Table'
import ButtonsList from './components/ButtonsList'

/** Export functions **/
import { exportCSVFile } from './components/Table/utils'

/** Validation schemas **/
import {
  ButtonsListSchema,
  CustomSchema,
  InlineTextSchema,
  PipeTextSchema,
  SingleTextSchema,
  TableSchema
} from './validators'

/** Pipe Directions **/
export const HORIZONTAL = 'horizontal'
export const VERTICAL = 'vertical'

/** Valid Factory types  **/
export const SINGLE_TEXT = 'SINGLE_TEXT'
export const INLINE_TEXT = 'INLINE_TEXT'
export const PIPE_TEXT = 'PIPE_TEXT'
export const TABLE = 'TABLE'
export const BUTTONS_LIST = 'BUTTONS_LIST'
export const CUSTOM = 'CUSTOM'

export const KPI_TYPES = {
  SINGLE_TEXT,
  INLINE_TEXT,
  PIPE_TEXT,
  TABLE,
  BUTTONS_LIST,
  CUSTOM
}

/** Factory map **/
export const factoryMap = {
  [SINGLE_TEXT]: {
    Element: SingleText,
    Schema: SingleTextSchema,
    download: noop
  },
  [INLINE_TEXT]: {
    Element: InlineText,
    Schema: InlineTextSchema,
    download: noop
  },
  [PIPE_TEXT]: {
    Element: PipeText,
    Schema: PipeTextSchema,
    download: noop
  },
  [TABLE]: {
    Element: Table,
    Schema: TableSchema,
    download: exportCSVFile
  },
  [BUTTONS_LIST]: {
    Element: ButtonsList,
    Schema: ButtonsListSchema,
    download: noop
  },
  [CUSTOM]: {
    Element: null,
    Schema: CustomSchema,
    download: noop
  }
}
